<template lang="pug">
  .component-backoffice-driver-list.row.column

    .row
      .column.small-4
        label Status
          select(v-model="search.status", :disabled="search.deleted")
            option(:value="null") All
            option NEW
            option WAITING
            option ACCEPTED
            option(value="AUTO_ACCEPTED") AUTO ACCEPTED
            option(value="AUTO_WAITING") AUTO WAITING
            option(value="AUTO_WAITING_OWFF") AUTO WAITING OWFF
            option(value="PENDING_CONFIRMATION") PENDING CONFIRMATION
            option(value="PENDING_ALLOCATION") PENDING ALLOCATION
            option(value="VOIDED") VOIDED
            option(value="COMPLETED") COMPLETED
            option REJECTED
      .column
        label SUB STATUS
          select(v-model="search.sub_status", :disabled="search.deleted")
            option(:value="null") All
            option(value="BACKOFFICE_ASSIGNED") BACKOFFICE ASSIGNED
            option(value="AUTO_ASSIGNED") AUTO ASSIGNED
      .column
        label Show deleted
          input-switch(v-model="search.deleted" )
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

import InputForm from "../../components/structure/ui/filters/InputForm";
import BaseList from "./BaseList";
import HeaderColumns from "../../components/structure/ui/HeaderColumns";
import DriverListForm from '../../components/structure/ui/filters/DriverListForm'
import InputSwitch from "../../components/structure/ui/InputSwitch.vue";

export default {
  name: "DriversReservationRequestList",
  components: {
    InputSwitch,
    DriverListForm,
    HeaderColumns,
    BaseList,
    InputForm,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/DriverReservationRequest.vue'),
      search: {
        status: null,
        sub_status: null,
        deleted: false,
      }
    }
  },
  methods: {
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.reservations.list(page, resultsPerPage).driversReservationRequests(this.search, (data) => {
        callback(data)
      })
    },
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriversReservationRequestList.vue?55c6e818